var render = function render(){var _vm=this,_c=_vm._self._c;return _c('picture',{staticClass:"picture"},[_c('img',{staticClass:"picture/image",staticStyle:{"object-fit":"contain"},attrs:{"draggable":"false","src":_vm.imageUrl,"loading":"lazy","onerror":"window.MoMA.onImageError(this, 1)","alt":_vm.altText}})])
}
var staticRenderFns = []

export { render, staticRenderFns }